import { printersUrl } from './resources.js'
import common from './common.js'
import store from '../store/index.js'
//
//Always get current restaurant from the store
//
async function getPrinterByRestaurant() {

    let restaurantid = store.state.restaurants.currentRestaurant.restaurantId;
    let url = `${printersUrl}/getbyrestaurant/${restaurantid}`;
    let data;
    await common.getDataWithToken(url)
                .then(response => {
                    data = response.printer });
    return data;
}


async function updatePrinter(data) {
    let url = `${printersUrl}/${data.categoryId}`;
    data.restaurantId = store.state.restaurants.currentRestaurant.restaurantId;
    await common.putData(url, data);
}

export default {
    name: 'printersService',
    getPrinterByRestaurant,
    updatePrinter,
}